import {
  INSTAGRAM_REPORT_CONTENT_ROWS,
  INSTAGRAM_REPORT_PERFORMANCE_ROWS,
} from 'app/modules/analytics/modules/reports/constants/reportMetricRowDefinitions';
import PlatformReportPreviewSections from './PlatformReportPreviewSections';
import type { ReportProfilePreviewSectionsProps } from '../types/ReportProfilePreviewSectionsProps';

const InstagramReportPreviewSections = (
  props: ReportProfilePreviewSectionsProps,
) => (
  <PlatformReportPreviewSections
    {...props}
    config={{
      performanceRows: INSTAGRAM_REPORT_PERFORMANCE_ROWS,
      contentRows: INSTAGRAM_REPORT_CONTENT_ROWS,
    }}
  />
);

export default InstagramReportPreviewSections;
